import { render } from "./SavedViewMenu.vue?vue&type=template&id=637a0afb&scoped=true"
import script from "./SavedViewMenu.vue?vue&type=script&lang=js"
export * from "./SavedViewMenu.vue?vue&type=script&lang=js"

import "./SavedViewMenu.vue?vue&type=style&index=0&id=637a0afb&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637a0afb"]])

export default __exports__